var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7298 24.9173V16.2923C40.7298 13.7507 39.7201 11.3131 37.9229 9.51588C36.1257 7.71865 33.6881 6.70898 31.1465 6.70898H14.8548C12.3132 6.70898 9.8756 7.71865 8.07838 9.51588C6.28115 11.3131 5.27148 13.7507 5.27148 16.2923V29.709C5.27148 30.9675 5.51936 32.2137 6.00097 33.3764C6.48258 34.5391 7.18848 35.5955 8.07838 36.4854C9.8756 38.2826 12.3132 39.2923 14.8548 39.2923H26.8532",
    stroke: "#D2042D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76953 32.5831L11.0212 26.4498C11.7109 25.7648 12.6161 25.3391 13.5836 25.2448C14.551 25.1505 15.5214 25.3934 16.3304 25.9323C17.1394 26.4712 18.1097 26.7141 19.0772 26.6198C20.0447 26.5255 20.9498 26.0998 21.6395 25.4148L26.1054 20.949C27.3886 19.6614 29.0875 18.8717 30.899 18.7207C32.7105 18.5698 34.5168 19.0674 35.9954 20.1248L40.7295 23.7856M15.3529 19.4923C15.7707 19.4898 16.1839 19.405 16.569 19.2428C16.954 19.0806 17.3034 18.8441 17.597 18.5469C17.8907 18.2496 18.1229 17.8975 18.2805 17.5105C18.4381 17.1235 18.5179 16.7093 18.5154 16.2915C18.5128 15.8736 18.4281 15.4604 18.2658 15.0754C18.1036 14.6903 17.8671 14.341 17.5699 14.0473C17.2727 13.7536 16.9205 13.5214 16.5336 13.3638C16.1466 13.2063 15.7324 13.1264 15.3145 13.129C14.4707 13.134 13.6635 13.4741 13.0704 14.0744C12.4773 14.6747 12.1469 15.486 12.152 16.3298C12.1571 17.1736 12.4972 17.9809 13.0975 18.574C13.6977 19.167 14.509 19.4974 15.3529 19.4923Z",
    stroke: "#D2042D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8555 28.75V38.3333",
    stroke: "#D2042D",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2508 32.7856L36.4807 29.0155C36.3988 28.9332 36.3014 28.8679 36.1942 28.8234C36.0869 28.7788 35.972 28.7559 35.8559 28.7559C35.7397 28.7559 35.6248 28.7788 35.5175 28.8234C35.4103 28.8679 35.3129 28.9332 35.231 29.0155L31.4609 32.7856",
    stroke: "#D2042D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImage);
export default __webpack_public_path__ + "static/media/upload-image.6db7fc00215392d47c78613eecf146c7.svg";
export { ForwardRef as ReactComponent };